{
  "confirmationNumber": "Confirmation Number {number}",
  "dateTimeRange": "{date} from {startTime} to {endTime}"
}
